import type { TrainingLessonSpecific } from './trainingLessonUi';

export const deacon1DutiesEs: TrainingLessonSpecific = {
  intro:
    'El oficio de diácono es el primer paso en el sacerdocio Aarónico. En esta lección aprenderás los deberes clave, la reverencia y la actitud de servicio que caracterizan a un diácono digno.',
  objectives: [
    'Entender el propósito del oficio de diácono.',
    'Identificar deberes clave de un diácono en el barrio.',
    'Aprender reverencia y conducta apropiada en la reunión sacramental.',
    'Entender por qué "ser diácono" es servir, no "tener un puesto".',
    'Establecer un plan simple semanal para cumplir deberes con dignidad.',
  ],
  briefHeading: 'Los deberes del diácono en breve',
  briefBody:
    'Un diácono ayuda al obispo y a los líderes del barrio. Sus deberes incluyen asistir en reuniones, preparar el salón, repartir la Santa Cena, y servir en orden. Ser diácono no es "tener un puesto": es representar al Salvador mediante el servicio humilde y la reverencia.',
  scriptures: [
    { ref: 'DyC 20:59', text: 'Velar por la iglesia... y ser con ella.' },
    { ref: 'DyC 84:111', text: 'Los oficios menores... para la ministración.' },
    { ref: 'Mosíah 2:17', text: 'Al servicio de vuestros semejantes...' },
    { ref: 'DyC 107:85–87', text: 'Deberes del diácono: ayudar y ministrar.' },
    { ref: '1 Timoteo 3:8–10', text: 'Dignidad y buen testimonio.' },
  ],
  didYouKnow: [
    'Un diácono no "solo pasa la Santa Cena": representa un ministerio de ayuda y orden en la Iglesia.',
    'La reverencia es parte del deber: no es "formalidad", es respeto por convenios.',
  ],
  practiceItems: [
    'Llegar 10 minutos antes y sentarme listo sin distracciones (1 domingo)',
    'Revisar mi apariencia: ropa limpia, ordenada, actitud tranquila',
    'Identificar 1 cosa que puedo hacer para ayudar a los líderes (orden/sillas/himnarios/puertas)',
    'Durante la reunión: no hablar, no jugar con el celular, ojos al frente',
    'Anotar una cosa del mensaje que me ayude a mejorar esta semana',
    'Hacer un acto de servicio sencillo en casa (sin que me lo pidan)',
  ],
  reflectionQuestions: [
    '¿Qué significa para mí "representar al Salvador" en un oficio?',
    '¿Qué me distrae más en la reunión? ¿Qué haré para controlarlo?',
    '¿A quién puedo servir esta semana de forma simple?',
  ],
  actionText:
    'Plan del domingo: elige una cosa concreta para prepararte mejor (ej.: dormir temprano sábado, ropa lista, leer 1 escritura antes de ir).',
};
